import config from '@/config'

const mintSecuredAccessCode = async ({ accessCode, uniqueAccessCode }) => {
  const res = await fetch(`${config.securedModeGatewayUrl}/secure`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ accessCode, uniqueAccessCode }),
  })
  if (!res.ok) throw new Error(`secure mint failed: ${res.status}`)
  return res.json()
}

export default { mintSecuredAccessCode }
